import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-commonworkflowlanguage',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Common Workflow Language icon</title><path d="M13.905 0L8.571 5.4l.037.037.096.096 3.586 3.395-2.24 2.252h-.01l-1.576 1.586 3.737 3.766-3.735 3.803.126.139v.012L12.052 24l1.608-1.64-1.98-2.034 3.737-3.79-1.608-1.642-.01.012-2.13-2.129 3.867-3.866-.017-.015.016-.016-3.641-3.524 3.64-3.694z"/></svg>`,
    styles: []
})
export class SimpleIconsCommonworkflowlanguageComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#B5314C';
    @Input() className: string = 'simple-icons-commonworkflowlanguage'
    constructor() {}
    ngOnInit(): void {}
}
